exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.number-input__input {\n  text-align: center;\n}\n", ""]);

// exports
